export interface UserType {
  _id?: string;
  username?: string;
  roles?:
  ('asistencia' |
  'ver datos' |
  'editar datos' |
  'registrar pagos' |
  'admin usuarios' |
  'admin grupos' |
  'admi cuotas' |
  'ver alertas' |
  'ver ingresos' |
  'admin torneos') []
  email?: string;
  lastName?: string;
  firstName?: string;
  token?: string;
}

export type AsistenciaType = { dia: string, asistencia?: boolean, obs?: string };

export interface AlumnoType {
  _id: string;
  user: string;
  fechanac: string;
  obs: string;
  grupo: string | null;
  fechains: string;
  direccion: string;
  celpapa: string;
  celmama: string;
  dni: string;
  apellido: string;
  name: string;
  asistencia: AsistenciaType[];
  inactivo?: boolean;
  descuentoHermano: boolean;
  cuotasAdeudadas?: { n: number, updated: string };
  becado: boolean;
  genero?: 'M' | 'F';
  federado?: boolean;
  categoria: CategoriasType;
  nivel: NivelesType;
}


export interface PayloadAlumnoType {
  _id?: string;
  user?: string;
  fechanac?: string;
  obs?: string;
  grupo?: string | null;
  fechains?: string;
  direccion?: string;
  celpapa?: string;
  celmama?: string;
  dni?: string;
  apellido?: string;
  name?: string;
  asistencia?: AsistenciaType[];
  inactivo?: boolean;
  descuentoHermano?: boolean;
  becado?: boolean;
  genero?: 'M' | 'F';
  federado?: boolean;
  categoria?: CategoriasType;
  nivel?: NivelesType;
}

export interface PagosType {
  user: string;
  anio: number;
  mes: number;
  importe: number;
  descuento: number;
  dni: number;
  marcarSaldado: boolean;
  esMatricula?: boolean;
  esSeguro?: boolean;
  pagos: {
    fecha: string;
    monto: number;
    obs: string;
    transferencia: boolean;
  }[]
}

export interface TorneoType {
  _id?: string;
  nombre?: string;
  fecha?: string;
  lugar?: string;
  organizador?: string;
  inscripcion?: number;
  generos?: string[];
  categorias?: string[];
  niveles?: string[];
  participantes?: string[];
  tipo?: string;
  pagaron?: string[];
}

export const categoriasFemenina = ['pre-escolar', 'pre-mini', 'mini', 'pre-infantil', 'infantil', 'juvenil', 'mayor'];
export const categoriasMasculina = ['pre-escolar', 'pre-mini', 'mini', 'menor', 'infantil', 'cadete', 'juvenil'];
export const categoriasMasculinaFederado = ['mini', 'pre-infantil', 'infantil', 'cadete', 'juvenil', 'junior', 'senior'];

export type CategoriaFemeninaType = typeof categoriasFemenina[number];
export type CategoriaMasculinaType = typeof categoriasMasculina[number];
export type CategoriaMasculinaFederadoType = typeof categoriasMasculinaFederado[number];

export const nivelesFemenina = ['E1', 'E2', 'E3'];
export const nivelesFemeninaFederado = ['USAG1', 'USAG2', 'USAG3', 'USAG4', 'USAG5', 'USAG6', 'USAG7', 'USAG8', 'USAG9'];
export const nivelesMasculina = ['E1', 'E2'];
export const nivelesMasculinaFederado = ['AC0', 'AC1', 'AC2', 'AC3', 'AC4'];

export type NivelesFemeninaType = typeof nivelesFemenina[number];
export type NivelesFemeninaFederadoType = typeof nivelesFemeninaFederado[number];
export type NivelesMasculinaType = typeof nivelesMasculina[number];
export type NivelesMasculinaFederadoType = typeof nivelesMasculinaFederado[number];

export type CategoriasType = CategoriaFemeninaType | CategoriaMasculinaType | CategoriaMasculinaFederadoType | null;
export type NivelesType = NivelesFemeninaType | NivelesFemeninaFederadoType | NivelesMasculinaType | NivelesMasculinaFederadoType | null;